import type { EnvoyWorkSetting, StandingOrder } from "@/lib/api/envoy";
import type { EnvoyDraft } from "@/lib/envoyForm";

/**
 * Where a first envoy starts: the last search the person ran on Jobs, so
 * Get new matches by email and Turn on my envoy begin from what they were
 * already looking at. Off until they turn it on; auto mode off.
 */

const LAST_SEARCH_KEY = "jobenvoy-last-search-v1";

const WORK_SETTINGS: readonly EnvoyWorkSetting[] = ["REMOTE", "HYBRID", "ON_SITE"];

/** Remembers the Jobs page's query string, when it searched for something. */
export function keepLastSearch(storage: Storage | undefined, search: string): void {
    const params = new URLSearchParams(search);
    if (!params.get("q")?.trim()) return;
    params.delete("posting");
    try {
        storage?.setItem(LAST_SEARCH_KEY, params.toString());
    } catch {
        // Storage refused: the envoy starts from nothing.
    }
}

/** The last search's query string, or empty. */
export function lastSearch(storage: Storage | undefined): string {
    try {
        return storage?.getItem(LAST_SEARCH_KEY) ?? "";
    } catch {
        return "";
    }
}

/** A first envoy's draft from a search: its words as the title, its settings, and the order. */
export function seedFromSearch(search: string, order: StandingOrder = "FIND"): Partial<EnvoyDraft> {
    const params = new URLSearchParams(search);
    const words = params.get("q")?.trim() ?? "";
    const settings = params
        .getAll("setting")
        .filter((value): value is EnvoyWorkSetting =>
            (WORK_SETTINGS as readonly string[]).includes(value),
        );
    return {
        ...(words ? { titles: [words] } : {}),
        ...(settings.length > 0 ? { workSettings: settings } : {}),
        order,
    };
}
